var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcPortfolioBalanceColorfulDark = function SvgIcPortfolioBalanceColorfulDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#384D4A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11,
    width: 17,
    height: 13,
    rx: 2,
    fill: "#2DD18D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16a1 1 0 0 1 1-1h5v4h-5a1 1 0 0 1-1-1v-2Z",
    fill: "#ADFFDD"
  })));
};
export default SvgIcPortfolioBalanceColorfulDark;